import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'

import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

// Registers `partnerId` as a PostHog super property so every subsequent event
// is attributed to the partner. `partnerConfig` resolves asynchronously, so the
// effect re-runs once the id becomes available.
export const usePartnerAnalyticsEffect = () => {
  const posthog = usePostHog()
  const { partnerConfig } = useEducationHostedForm()
  const partnerId = partnerConfig?.partner?.id

  useEffect(() => {
    if (!posthog || !partnerId) return

    posthog.register({ partnerId })
  }, [posthog, partnerId])
}
